import { Component } from 'preact-compat';
import cn from 'classnames';
import PropTypes from 'prop-types';
import s from './scss/thumbbar.scss';

export default class ThumbBar extends Component {
  static propTypes = {
    absPath: PropTypes.string.isRequired,
    imgPath: PropTypes.string.isRequired,
    interior: PropTypes.object.isRequired,
    thumbbarHoverToggle: PropTypes.func.isRequired,
    thumbbarOpenToggle: PropTypes.func.isRequired,
    thumbbarOpen: PropTypes.bool.isRequired,
    setActiveInterior: PropTypes.func.isRequired,
    showtext: PropTypes.string.isRequired,
    hidetext: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      greaterVw: false
    };

    this.setupThumbRef = element => {
      this.thumb = element;
    };
  }

  componentDidMount() {
    this.scrollToThumb(this.props.interior.index);
  }

  componentDidUpdate() {
    const { interior, vw } = this.props;

    const { greaterVw } = this.state;

    const thumbLength = interior.config.length;
    const greaterThanVw = vw >= this.thumb.offsetWidth * thumbLength;
    if (greaterThanVw !== greaterVw) {
      this.setState({
        greaterVw: greaterThanVw
      });
    }
  }

  // activate selected Thumb
  activateThumb = i => {
    const { setActiveInterior, resetLoad } = this.props;

    // reset Loader
    resetLoad();
    // activate new interior
    setActiveInterior(i);
    this.scrollToThumb(i);
  };

  scrollToThumb = i => {
    const { vw } = this.props;

    const scrollPos = this.thumb.offsetWidth * i;
    const finalPos = parseInt(scrollPos - (vw - this.thumb.offsetWidth) / 2);
    this.scrollAmount = this.content.scrollLeft;
    window.clearInterval(this.slideTimer);

    this.slideTimer = setInterval(() => {
      const slideFactor = finalPos > this.scrollAmount ? +1 : -1;
      this.content.scrollLeft = this.content.scrollLeft + slideFactor;
      this.scrollAmount = this.scrollAmount + slideFactor;
      if (
        (this.scrollAmount >= finalPos && finalPos > this.scrollAmount) ||
        (this.scrollAmount <= finalPos && finalPos <= this.scrollAmount)
      ) {
        window.clearInterval(this.slideTimer);
      }
    }, 5);
  };

  render() {
    const {
      interior,
      absPath,
      thumbbarOpen,
      thumbbarOpenToggle,
      thumbbarHoverToggle,
      showtext,
      hidetext
    } = this.props;

    const contentStyle = this.state.greaterVw && { justifyContent: 'flex-end' };
    return (
      <div
        className={cn(s.thumbBar, thumbbarOpen && s.open)}
        onMouseOver={() => thumbbarHoverToggle(true)}
        onMouseOut={() => thumbbarHoverToggle(false)}
      >
        <div className={s.trigger}>
          <div className={s.label} onClick={() => thumbbarOpenToggle()}>
            {thumbbarOpen ? hidetext : showtext}
          </div>
          <div className={cn(s.icon, thumbbarOpen && s.open)} onClick={() => thumbbarOpenToggle()}>
            <img src={`${absPath}assets/icons/collapse_arrow.svg`} />
          </div>
        </div>
        <div
          className={cn(s.content, thumbbarOpen && s.open)}
          ref={content => (this.content = content)}
          style={contentStyle}
        >
          {interior.config.map((option, i) => {
            const isActive = interior.index === i;
            const thumbClass = cn(s.thumb, isActive && s.active);
            return (
              <div
                className={thumbClass}
                ref={this.setupThumbRef}
                onClick={() => !isActive && this.activateThumb(i)}
              >
                <div className={s.imgwrapper}>
                  <img src={`${absPath}assets/icons/${option.imgSrc}`} />
                </div>
                <div className={s.desc}>/{option.desc1}</div>
                {option.desc2 !== '' && <div className={s.desc}>/{option.desc2}</div> }
                {option.desc3 !== '' && <div className={s.desc}>/{option.desc3}</div> }
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/thumbbar/thumbbar.js